import type { MembershipPassDownloadProps } from './membership-pass-download.component';

/**
 * Maps HTML attribute names (kebab-case) to Component prop names (camelCase)
 */
export const MEMBERSHIP_PASS_DOWNLOAD_ATTRIBUTE_MAP: Record<
  string,
  keyof MembershipPassDownloadProps
> = {
  'membership-id': 'membershipId',
};

/**
 * Extracts attributes from an HTMLElement and converts them to Component props
 */
export function extractMembershipPassDownloadAttributes(
  element: HTMLElement
): Partial<MembershipPassDownloadProps> {
  const props: Partial<MembershipPassDownloadProps> = {};
  for (const [attrName, propName] of Object.entries(MEMBERSHIP_PASS_DOWNLOAD_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = value;
    }
  }
  return props;
}
